import { Estimation } from '@aviv-estimation-funnel/estimation-data-models/models';
import { authenticate } from '@mfe-helpers/authentication/authenticate';
import { mapTenantToPortal } from '@mfe-helpers/authentication/tenant';
import { Dispatch } from 'react';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { ResultStatus } from '@mfe-presentation/constants/userVerification';
import { IAction, EActionType } from '@mfe-types/context';

import { httpService } from './http';

const WLEF_API_URL = process.env['NX_WLEF_API_URL'];
const WLEF_API_KEY = process.env['NX_WLEF_API_KEY'];

export interface PhoneNumberValidationResult {
    readonly phoneNumber: string;
    readonly status: ResultStatus;
    readonly verificationRequestId?: string;
}

// TODO [WLEF-476] typage form
// export interface IForm {}

export const submitForm = async (
    form: Record<string, any>,
    dispatch?: Dispatch<IAction>,
): Promise<Estimation> => {
    const AUTHENTICATION_ENABLED = process.env['NX_OAUTH_AUTHENTICATION_ENABLED'] === 'true';

    const { portal } = form;

    const shouldPortalUsePortalUserId = portal === Portal.Immonet || portal === Portal.ImmoWelt;
    const shouldPortalUseAvivUserId = portal === Portal.SeLoger;

    if (AUTHENTICATION_ENABLED && (shouldPortalUsePortalUserId || shouldPortalUseAvivUserId)) {
        const result = await authenticate(portal);

        const portalFromCookie = mapTenantToPortal(result?.tenant);
        const isSupportedPortalFromCookie = portalFromCookie === portal;

        if (result && isSupportedPortalFromCookie) {
            if (shouldPortalUseAvivUserId) {
                form.avivUserId = result.avivUserId;
            }
            if (shouldPortalUsePortalUserId) {
                form.portalUserId = result.sub;
            }

            dispatch?.({
                type: EActionType.SetIsAuthenticated,
                payload: true,
            });
        }
    }

    const { data } = await httpService.post<Estimation>(`${WLEF_API_URL}/v1/estimations`, form, {
        headers: {
            'x-api-key': WLEF_API_KEY,
        },
    });
    return data;
};
